import type { ColorId } from '@api-client/products';

import type { Card } from './types/aggregationService';

export const mapCardWithCustomizationFallback = (card: Card) => {
    if (card._embedded.customization) {
        return card;
    }

    return {
        ...card,
        _embedded: {
            ...card._embedded,
            customization: {
                name: card.localizedName,
                color: { id: 'INDIGO' as ColorId },
                hiddenOnOverview: false,
                changes: [],
                favorite: false,
                labels: [],
            },
        },
    };
};
